import { cn } from '@/lib/utils'
import { Div, Icon } from '@/ui/components'
import { ComponentProps } from 'react'

interface ItemProps extends React.HTMLAttributes<HTMLAnchorElement> {
  icon?:
    | 'facebook'
    | 'x'
    | 'instagram'
    | 'linkedin'
    | 'threads'
    | 'sharelink'
    | 'youtube'
  href: string
}

const Item = ({ icon, className, children, ...props }: ItemProps) => {
  const iconMap = {
    facebook: 'dashicons:facebook-alt',
    x: 'ri:twitter-x-line',
    instagram: 'uil:instagram',
    linkedin: 'flowbite:linkedin-solid',
    threads: 'meteor-icons:threads',
    sharelink: 'stash:link-solid',
    youtube: 'uil:youtube'
  }

  return (
    <a
      className={cn(
        className,
        'global-focus flex size-9 items-center justify-center rounded-full border border-neutral-600'
      )}
      {...props}
      target="_blank"
      rel="noreferrer"
      aria-label={`${icon ? icon : props['aria-label']} social link`}
    >
      {children || (icon && <Icon icon={iconMap[icon]} className="size-5" />)}
    </a>
  )
}

const Wrapper = ({
  className,
  children,
  ...props
}: ComponentProps<typeof Div>) => (
  <Div className={cn('gap-sm my-2xl flex', className)} {...props}>
    {children}
  </Div>
)

export { Item, Wrapper }
